/**
 * Storage utility that delegates to the platform-specific storage service.
 * Electron: userData JSON file via IPC
 * Capacitor (Android): @capacitor/preferences
 * Web: localStorage
 */

import { getPlatformServices } from '@/services/platform';

class StorageService {
  async getItem(key: string): Promise<string | null> {
    return getPlatformServices().storage.get(key);
  }

  async setItem(key: string, value: string): Promise<void> {
    return getPlatformServices().storage.set(key, value);
  }

  async removeItem(key: string): Promise<void> {
    return getPlatformServices().storage.remove(key);
  }
}

export const storage = new StorageService();
